import { Box, Button, Typography } from "@mui/material";
import MyAutocomplate from "../autocomplete/autocomplete";
import { useContext, useEffect, useState } from "react";
import { RequestContext } from "../../context/request.context";

const TelegramUpdate = ({ user, close }) => {
  const { request } = useContext(RequestContext);
  const [telegramUsers, setTelegramUsers] = useState([]);
  const [selectedTelegramUser, setSelectedTelegramUser] = useState(
    user.botUser
  );
  useEffect(() => {
    request("/telegram/users?size=10000", "GET").then((data) => {
      setTelegramUsers(data.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const connectTelegram = async () => {
    await request(
      `/user/bot-user/${user.id}?botUserId=${selectedTelegramUser.id}`,
      "PATCH"
    );
    close();
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "1rem",
      }}
    >
      <Typography variant="body1">Telegram Ulash</Typography>
      <MyAutocomplate
        label="Telegram foydalanuvchisini tanlang"
        options={telegramUsers}
        value={selectedTelegramUser}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, options) => {
          return (
            <li {...props} key={options.id}>
              <Typography variant="body2">{options.name}</Typography>
            </li>
          );
        }}
        getValue={(value) => {
          setSelectedTelegramUser(value);
        }}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        onClick={connectTelegram}
        disabled={selectedTelegramUser === null}
      >
        Saqlash
      </Button>
    </Box>
  );
};

export default TelegramUpdate;
